export default __webpack_public_path__ + "media/images/menu-icon/cafe-38e871e63674838d6be6f437a936ccd2.png";